"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var contact_1 = require("./contact");
exports.ContactService = contact_1.ContactService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/contact/services/index.js
// module id = 449
// module chunks = 0